/**
 * Pastel SVG balloon shape used as a background decoration.
 * Animated via parent's .balloon / .balloon-N CSS classes.
 */
export function BalloonSVG({ color = '#FFB3D9', size = 70 }) {
  return (
    <svg
      width={size}
      height={Math.round(size * 1.35)}
      viewBox="0 0 60 81"
      fill="none"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Body */}
      <ellipse cx="30" cy="27" rx="26" ry="27" fill={color} />
      {/* Shine highlight */}
      <ellipse
        cx="20" cy="15" rx="7" ry="5" fill="white" opacity="0.28"
        transform="rotate(-25 20 15)"
      />
      {/* Knot */}
      <circle cx="30" cy="55" r="3.5" fill={color} opacity="0.85" />
      {/* String */}
      <path
        d="M30 58.5 Q36 68 29 78"
        stroke={color} strokeWidth="1.5" strokeLinecap="round" opacity="0.5"
      />
    </svg>
  )
}

// Preset balloon colours matching the design system pastels
export const BALLOON_COLORS = {
  pink:    '#FFB3D9',
  yellow:  '#FFE066',
  lavender:'#C4B5FD',
  mint:    '#86EFAC',
}

// Ready-made scattered balloon decoration layer
// place inside a relative-positioned section
export function BalloonLayer({ opacity = 0.55 }) {
  const POSITIONS = [
    { color: BALLOON_COLORS.pink,     top: '8%',  left: '3%',  size: 70,  delay: 'balloon-1' },
    { color: BALLOON_COLORS.yellow,   top: '15%', right: '5%', size: 55,  delay: 'balloon-2' },
    { color: BALLOON_COLORS.lavender, top: '55%', left: '1%',  size: 60,  delay: 'balloon-3' },
    { color: BALLOON_COLORS.mint,     top: '65%', right: '3%', size: 65,  delay: 'balloon-4' },
    { color: BALLOON_COLORS.pink,     top: '40%', right: '8%', size: 45,  delay: 'balloon-2' },
    { color: BALLOON_COLORS.yellow,   top: '80%', left: '6%',  size: 50,  delay: 'balloon-1' },
  ]

  return (
    <>
      {POSITIONS.map(({ color, size, delay, ...pos }, i) => (
        <span
          key={i}
          className={`balloon ${delay} absolute pointer-events-none`}
          style={{ ...pos, opacity }}
        >
          <BalloonSVG color={color} size={size} />
        </span>
      ))}
    </>
  )
}
